import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FaExclamationCircle } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { setformmodal, saveContactapi } from "../Redux/Globalslice"; // ✅ Make sure this is correctly imported
import { RxCross2 } from "react-icons/rx";
const ContactModal = () => {
    const dispatch = useDispatch();
    const formmodal = useSelector((state) => state.Globalslice.formmodal);
    const formloading = useSelector((state) => state.Globalslice.formloading);

    const handleClose = () => dispatch(setformmodal(false));

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
    });


    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = "Name is required";
        if (!formData.email) newErrors.email = "Email address is required";
        else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Invalid email";
        if (!formData.phone) newErrors.phone = "Number is required";
        if (!formData.subject) newErrors.subject = "Subject is required";
        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validate();
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length === 0) {
            // console.log("formData", formData)
      
            dispatch(saveContactapi(formData));
        }
    };

    return (
        <Modal show={formmodal} onHide={handleClose} size="lg" centered>
            <Modal.Body className="formmodalbody">
                <div className="formmodal-close">
                    <RxCross2 className="cursour-pointer" size={25} onClick={handleClose} />
                </div>

                <div className="text-start mb-4">

                    <h3>
                        <strong>Ready to <span className="form-getstarted">Get Started?</span></strong>
                    </h3>
                    <p className="text-muted">Please, fulfill the form to get a consultation</p>
                </div>
                <Form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <Form.Control
                                type="text"
                                placeholder="Your Name *"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                isInvalid={!!errors.name}
                            />
                            {errors.name && (
                                <div className="error-msg">
                                    <FaExclamationCircle className="me-1" />
                                    {errors.name}
                                </div>
                            )}
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Control
                                type="email"
                                placeholder="Your Email *"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                isInvalid={!!errors.email}
                            />
                            {errors.email && (
                                <div className="error-msg">
                                    <FaExclamationCircle className="me-1" />
                                    {errors.email}
                                </div>
                            )}
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Control
                                type="text"
                                placeholder="Your Phone *"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                isInvalid={!!errors.phone}
                            />
                            {errors.phone && (
                                <div className="error-msg">
                                    <FaExclamationCircle className="me-1" />
                                    {errors.phone}
                                </div>
                            )}
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Control
                                type="text"
                                placeholder="Your Subject *"
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                isInvalid={!!errors.subject}
                            />
                            {errors.subject && (
                                <div className="error-msg">
                                    <FaExclamationCircle className="me-1" />
                                    {errors.subject}
                                </div>
                            )}
                        </div>
                        <div className="col-12 mb-3">
                            <Form.Control
                                as="textarea"
                                rows={4}
                                placeholder="Message..."
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="formmodalbutton">
                            <Button type="submit" className="formmodalbutton submit-formmodalbutton">
                                SUBMIT NOW 
                                {
                                    formloading &&
                                
                                  <span class="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
                                }
                                  </Button>
                        </div>
                    </div>

                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default ContactModal;
